<!-- <template functional>
  <div class="dbox-textarea-container"
  >
    <textarea 
      :name="props.id"
      :id="props.id" 
      :value="props.value"
      v-on="listeners"
    >
    </textarea>
  </div>
</template> -->

<template>
  <div
    :class="`dbox-textarea-container`"
    :style="{
      backgroundColor: yellowStyle ? 'var(--bc-note)' : '',
      opacity: disabled ? '0.5' : `1`,
    }"
  >
    <textarea
      :style="{
        overflow: value && value.length > 0 ? 'auto' : 'hidden',
        height: !heightAuto ? `${height}px` : `auto`,
      }"
      :name="id"
      :id="id"
      :value="value"
      ref="textarea"
      @blur="onBlur"
      @input="onInput"
      :disabled="disabled"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    yellowStyle: {
      type: Boolean,
      default: true,
    },
    // height: {
    //   type: Number,
    // },
    maxHeight: {
      type: Number,
      default: 322,
    },
    minHeight: {
      type: Number,
      default: 62,
    },
  },
  data() {
    return {
      height: 62,
      heightAuto: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (to, from) {
        this.height = 62;
        this.$nextTick(() => {
          this.syncHeight(); 
          // this.$emit("height_calc", this.$refs["textarea"].scrollHeight);
        });
      },
    },
  },


  methods: {
    syncHeight() {
      console.log(' this.$refs?.["textarea"]', this.$refs?.["textarea"])
      const height = this.$refs?.["textarea"]?.scrollHeight;
      // console.log({[this.id] : this.maxHeight});
      this.height =
        height > this.maxHeight
          ? this.maxHeight
          : height < this.minHeight
          ? this.minHeight
          : height + 2; // Added a Offset of 2 because a Mac Device from Simo was showing Scrollbars for 4th and 5th Row
    },
    onBlur: function (event) {
      // this.$emit("height_calc", this.$refs["textarea"].scrollHeight);
      this.$emit("blur", event);

      this.heightAuto = true;
      this.$nextTick(() => {
        this.syncHeight();
        this.heightAuto = false;
      });
    },
    onInput: function (event) {},
  },
};
</script>
